export enum ImageType {
  Cropped = 'cropped',
  Card = 'card',
  Original = 'original',
}
